import { render, staticRenderFns } from "./TableSingleSwapTournament.vue?vue&type=template&id=33aa66e2&scoped=true"
import script from "./TableSingleSwapTournament.js?vue&type=script&lang=js&external"
export * from "./TableSingleSwapTournament.js?vue&type=script&lang=js&external"
import style0 from "./TableSingleSwapTournament.vue?vue&type=style&index=0&id=33aa66e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa66e2",
  null
  
)

export default component.exports